application.register("comp_gallery_photobook", class extends Stimulus.Controller {
    connect() {
        this.handleResize = this.updateLayout.bind(this);
        this.initialized = false;

        cssLoaded(() => {
            this.updateLayout();
            window.addEventListener("resize", this.handleResize, { passive: true });
        });
    }

    disconnect() {
        window.removeEventListener("resize", this.handleResize);
    }

    updateLayout() {
        let maxWidth = window.innerWidth;
        let ratio = 1;

        [...this.element.querySelectorAll("[data-width]")].map((item) => {
            let width = Number(item.dataset["width"]);

            if (width >= maxWidth && (width / maxWidth) > ratio) {
                ratio = width / maxWidth;
            }
        });

        if (window.innerWidth < 961) {
            ratio *= 1.2;
        }

        [...this.element.querySelectorAll("[data-width]")].map((item) => {
            item.style.width = (Number(item.dataset["width"]) / ratio) / maxWidth * 100 + "%";
        });

        if (!this.initialized) {
            this.element.scrollLeft = 0;
            this.initialized = true;
        }

        this.element.dispatchEvent(new Event("scroll"));
    }
});
